<template>
    <div class="sidebar-outline" :class="{closed: isClose}">
        <button type="button"
            id="btn-toggle"
            class="btn"
            :class="{
                closed: isClose,
                'btn-dark': $store.state.background_color == 'black',
                'btn-outline-secondary': $store.state.background_color != 'black'
            }"
            @click.stop="toggle()">
            <i class="fas fa-book-open" v-if="isClose"></i>
            <i class="fas fa-times" v-else></i>
        </button>
        <div class="sidebar" id="content-sidebar" :class="{
            'closed': isClose
        }" @click.stop="">
            <div class="sidebar-body">
                <div class="sidebar-wrapper" v-if="book">
                    <div class="sidebar-sticky b-normal bg-blur">
                        <h1 class="bookshelf-name b-dark">
                            <img :src="favicon" class="favicon d-inline-block align-top" :alt="$store.state.bookshelf_name">
                            <router-link to="/" class="stretched-link text-reset">
                                <span v-html="$filters.ruby($store.state.bookshelf_name)"></span>
                            </router-link>
                        </h1>
                        <h3 class="book-title">
                            <router-link :to="`/author/book/${book.id}`" v-if="book.is_long">
                                <span v-html="$filters.ruby(book.title)"></span>
                            </router-link>
                            <span v-else v-html="$filters.ruby(book.title)"></span>
                        </h3>
                        <h4 class="book-subtitle" v-if="book.subtitle" v-html="$filters.ruby(book.subtitle)"></h4>
                        <h5 class="book-author my-2" v-if="book.author">
                            <router-link to="/" class="black" v-if="book?.author?.subdomain && book.author.subdomain == $store.state?.subdomain">
                                {{book.author.name}}
                            </router-link>
                            <a :href="subdomain" target="_blank" v-else>
                                {{book.author.name}}
                            </a>
                        </h5>
                        <div class="mx-2 my-4">
                            <div class="btn-group btn-block">
                                <button class="btn btn-secondary btn-sm" @click="showLayout()">
                                    <i class="fas fa-sliders-h"></i>
                                    あぁ
                                </button>
                                <button class="btn btn-secondary btn-sm" @click="startReadingTracker()">
                                    <i class="fas fa-book-reader"></i>
                                    リーディングトラッカー
                                </button>
                            </div>
                        </div>
                        <div class="mx-2 my-4">
                            <div class="d-flex justify-content-end noborder">
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                    :class="{
                                        'btn-outline-primary': !book.favorite,
                                        'btn-outline-danger': book.favorite,
                                    }"
                                    data-toggle="tooltip"
                                    title="お気に入り"
                                    v-if="$store?.state?.user && !isMyBook"
                                    @click="toggleFavorite()">
                                    <i class="fas fa-minus-square" v-if="book.favorite"></i>
                                    <i class="fas fa-bookmark" v-else></i>
                                </button>
                                <button type="button" class="btn btn-sm btn-outline-success"
                                    :class="{'btn-outline-danger': book.hondana_id}"
                                    data-toggle="tooltip"
                                    title="展示棚"
                                    v-if="$store?.state?.user && !isMyBook"
                                    @click="$emit('toggleHondana')">
                                    <i class="fas fa-book-open" v-if="!book.hondana_id"></i>
                                    <i class="far fa-times-circle" v-else></i>
                                </button>
                                <a :href="'https://bsky.app/intent/compose?text='+tweet()"
                                    target="_blank"
                                    data-toggle="tooltip"
                                    title="この小説を投稿"
                                    class="btn btn-outline-secondary btn-sm btn-icon">
                                    <img src="/img/bluesky.svg">
                                </a>
                                <a :href="'https://taittsuu.com/share?text='+tweet()"
                                    target="_blank"
                                    data-toggle="tooltip"
                                    title="この小説をタイーツ"
                                    class="btn btn-outline-secondary btn-sm btn-icon">
                                    <img src="/img/taittsuu.png">
                                </a>
                                <a :href="'https://x.com/intent/tweet?text='+tweet()"
                                    target="_blank"
                                    data-toggle="tooltip"
                                    title="この小説をPOST"
                                    class="btn btn-outline-dark btn-sm">
                                    <i class="fab fa-twitter"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div id="contents" v-if="book.is_long">
                        <div class="list-group list-group-flush" id="list-group-content" v-if="sections.length > 0">
                            <a href="#"
                                v-for="s in sections"
                                :key="s.id"
                                @click.prevent="turnThePage(s.id)"
                                class="list-group-item list-group-item-action"
                                :class="{
                                    active: $route.params.id == s.id,
                                    disabled: s.is_chapter,
                                    chapter: s.is_chapter,
                                    'b-dark': s.is_chapter,
                                }"
                            >
                                <i class="fas fa-bookmark" v-if="$route.params.id == s.id"></i>
                                <span v-html="$filters.ruby(s.section_name || '（無題）')"></span>
                            </a>
                        </div>
                    </div>
                    <div class="book-information">
                        <h6>書籍情報</h6>
                        <dl class="row" v-if="book.property">
                            <dt class="col-sm-3">ジャンル</dt>
                            <dd class="col-sm-9">
                                <span v-if="book.genre">{{book.genre.genre_name}}</span>
                                <span v-else>ジャンルなし</span>
                                <span v-if="book.is_long" class="badge badge-primary">長編</span>
                                <span v-else class="badge badge-warning">短編</span>
                            </dd>
                            <dt class="col-sm-3" v-if="book.series">
                                シリーズ
                            </dt>
                            <dd class="col-sm-9" v-if="book.series">
                                <router-link :to="'/author/series/' + book.series.id">
                                    {{book.series.series_name}}
                                    <i class="fas fa-layer-group"></i>
                                </router-link>
                            </dd>
                            <dt class="col-sm-3">文字数</dt>
                            <dd class="col-sm-9">{{$filters.numberFormat(book.property.published_chars )}}文字</dd>
                            <dt class="col-sm-3">初回公開</dt>
                            <dd class="col-sm-9">{{$filters.dateFormat(book.property.first_published_at , 'LLLL')}}</dd>
                            <dt class="col-sm-3">最新公開</dt>
                            <dd class="col-sm-9">{{$filters.dateFormat(book.property.last_published_at , 'LLLL')}}</dd>
                            <dt class="col-sm-3" v-if="book.urls && book.urls.length">投稿先</dt>
                            <dd class="col-sm-9" v-if="book.urls && book.urls.length">
                                <site v-for="u in book.urls" :key="u.id" :url="u.url" :domain="u.domain"></site>
                            </dd>
                            <dt class="col-sm-3" v-if="book.tags && book.tags.length">タグ</dt>
                            <dd class="col-sm-9" v-if="book.tags && book.tags.length">
                                <ul class="tag-list mx-0">
                                    <li v-for="t in book.tags" :key="t.id">
                                        <router-link :to="'/search?keywords=' + encodeURI(t.tag_name)" class="text-reset">
                                            {{t.tag_name}}
                                        </router-link>
                                    </li>
                                </ul>
                            </dd>
                            <dt class="col-sm-3" v-if="book.banner && book.banner.picture">バナー</dt>
                            <dd class="col-sm-9" v-if="book.banner && book.banner.picture">
                                <img :src="book.banner.picture.url +'?'+ book.banner.picture.hash" alt="小説リンクバナー" class="img-thumbnail img-link">
                            </dd>
                        </dl>
                    </div>
                    <div class="m-3" v-if="book.property && book.property.is_finished && book.has_epub">
                        <a :href="`/author/book/epub?id=${book.id}`" class="btn btn-outline-warning btn-sm btn-block">
                            電子書籍をダウンロード
                        </a>
                    </div>
                    <div class="m-3" v-if="articles.length">
                        <article-card v-for="a in articles"
                            :article="a"
                            :showPreface="false"
                            :bg="false"
                            :h100="false"
                            :key="'article-' + a.id"></article-card>
                    </div>
                    <div class="spacer"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.sidebar-outline {
    height: 100dvh;
    width: 0px;
    top: 0px;
    right: 0px;
    position: fixed;
    overflow-y: visible;
    overflow-x: visible;
    &.closed {
        right: -340px;
    }
    #btn-toggle {
        position: fixed;
        top: 5px;
        right: 340px;
        transition: 0.2s ease;
        border-radius: .2em 0 0 .2em;
        border: 0;
        box-shadow: none;
        background-color: rgb(255, 255, 255, .5);
        &:hover {
            background-color: rgb(0, 0, 0, .5);
        }
        &.closed {
            right: 0;
        }
    }
    .sidebar {
        height: 100dvh;
        width: 340px;
        position: fixed;
        top: 0px;
        right: 0px;
        overflow-y: auto;
        overflow-x: auto;
        transition: 0.2s ease;
        font-size: .9rem;
        border-left: 1px solid #aaa;
        -ms-overflow-style: none;
        scrollbar-width: none;
        &::-webkit-scrollbar {
            display:none;
        }
        &.b-white { background-color: white; }
        &.b-black {
            background-color: #333;
            color: snow !important;
            a, h5 {
                color: snow !important;
            }
            .list-group-item {
                border-color: #999;
            }
        }
        &.closed {
            right: -340px;
        }
        .sidebar-body {
            .sidebar-wrapper {
                .sidebar-sticky {
                    position: sticky;
                    z-index: 99;
                    top: 0px;
                    padding-bottom: 1rem;
                }
                .noborder {
                    .btn {
                        border-color: transparent;
                    }
                }
                .list-group-item {
                    background-color: transparent;
                    &.active {
                        background-color: #3490dc;
                        &:hover {
                            background-color: #297abd;
                        }
                    }
                    &:hover, &.disabled {
                        background-color: rgba(127, 127, 127, 0.1);
                    }
                }
                width: 340px;
                margin-left: 0px;
                .book-information {
                    font-size: .7rem;
                    margin: 2rem 0 0;
                    padding: 1rem;
                    h6 {
                        padding: .5rem 0;
                        border-bottom: 1px solid #ddd;
                    }
                }
            }
        }
        .btn-icon {
            img {
                width: 16px;
                height: 16px;
            }
            &:hover {
                img {
                    filter: brightness(2);
                }
            }
        }
        .chapter {
            font-weight: bold;
        }
        .bookshelf-name {
            .favicon {
                width: 1rem;
                height: 1rem;
                border-radius: .2rem;
            }
            position: relative;
            padding: 1rem 0 1rem 1rem;
            font-size: 0.9rem;
        }
        .book-title {
            padding: 1rem 1rem 0;
            margin-bottom: 0;
            font-size: 1.2rem;
            a {
                color: #222;
            }
        }
        .book-subtitle {
            font-size: .8rem;
            padding: 1rem;
            line-height: 1.6rem;
        }
        .book-author {
            font-size: .8rem;
            color: #777;
            padding: 0rem 1rem;
            text-align: right;
        }
    }
    .spacer {
        width: 100%;
        min-height: 1px;
    }
}
@media screen and (max-width: 374px) {
    .sidebar-outline {
        &.closed {
            right: calc((100vw - 34px) * -1);
        }
        #btn-toggle {
            right: calc(100vw - 34px);
        }
        .sidebar {
            width: calc(100vw - 34px);
            &.closed {
                right: calc((100vw - 34px) * -1);
            }
            .sidebar-body {
                .sidebar-wrapper {
                    width: calc(100vw - 34px);
                }
            }
        }
    }
}
</style>

<script>
import Site from "components/Site";
import articleCard from "../articleCard";
export default {
    components: {
        Site,
        articleCard,
    },
    props: {
        book: {
            required: true,
        },
        sections: {
            required: true,
        },
        articles: {
            default: [],
        }
    },
    data() {
        return {
            isClose: false,
        }
    },
    methods: {
        toggle() {
            this.isClose = !this.isClose;
            this.$emit("toggle", this.isClose);
            if (!this.isClose) {
                if (this.book.is_long) {
                    const height = $(".sidebar-sticky")[0].clientHeight || 225;
                    const top = $("#list-group-content .active")[0].offsetTop - height;
                    $("#content-sidebar").animate({scrollTop: top}, 500);
                }
            }
        },
        resized() {
            if (this.isClose) return;
            let width = window.innerWidth;
            if (width <= 1340) {
                this.isClose = true;
                this.$emit("toggle", this.isClose);
            } else {
                this.isClose = !this.$store.state.is_horizontal;
                this.$emit("toggle", this.isClose);
            }
        },
        toggleFavorite() {
            axios.post("/author/book/favorite/toggle", {id: this.book.id}).then(res => {
                this.$emit("reloadBook")
            }).catch(err => {
                alert.err(err.response);
            });
        },
        tweet() {
            if (!this.book || !this.book.author) return null;
            let url;
            let subdomain = "www";
            if (this.book.author.subdomain) {
                subdomain = this.book.author.subdomain;
            }
            if (this.book.is_long) {
                url = `https://${subdomain}${this.$store.state.base_domain}/author/book/${this.book.id}`;
            } else {
                const id = this.sections[0]?.id;
                url = `https://${subdomain}${this.$store.state.base_domain}/author/page/${this.book.id}/section/${id}`;
            }
            let sitename;
            if (this.$store.state.bookshalf_name) {
                sitename = this.$store.state.bookshalf_name;
            } else {
                sitename = "貸し本棚";
            }
            return encodeURI(this.book.title + " - " + sitename + "\n" + url);
        },
        startReadingTracker() {
            this.toggle();
            this.$emit("startReadingTracker");
        },
        showLayout() {
            this.inspectToggle();
            this.$emit("showLayout");
        },
        turnThePage(id) {
            this.inspectToggle();
            this.$router.push(`/author/page/${this.book.id}/section/${id}`);
        },
        inspectToggle() {
            if (window.innerWidth < 1340 || !this.$store.state.is_horizontal) {
                // 縦書きのときなどサイドバーが被る場合は閉じる
                this.toggle();
            }
        },
    },
    watch: {
        '$store.state.is_horizontal'() {
            this.resized();
        }
    },
    computed: {
        isMyBook() {
            if (this.book?.user_id == this.$store?.state?.user?.id) {
                return true;
            }
            return false;
        },
        favicon() {
            if (this.$store.state.favicon) {
                return this.$store.state.favicon;
            }
            return "/favicon.png";
        },
        subdomain() {
            if (this.book?.author?.subdomain) {
                return `//${this.book.author.subdomain}${this.$store.state.base_domain}/`;
            }
            return `//www${this.$store.state.base_domain}/`;
        },
    },
    mounted() {
        $(window).on("resize", this.resized);
        this.resized();
        setTimeout(() => {
            $('[data-toggle="tooltip"]').tooltip();
        }, 1000);
    }
}
</script>